import { FC } from 'react'
import GroupIcon from '@mui/icons-material/Group'
import PersonIcon from '@mui/icons-material/Person'
import { Box, Typography } from '@mui/material'

import { LessonDto, LessonType } from '../../../service/types'
import { getCustomerNames, getSkierCount } from './lessonDisplay'

type Props = {
  lesson: LessonDto
}

export const LessonBlockContent: FC<Props> = ({ lesson }) => (
  <Box sx={{ position: 'relative', width: '100%', alignSelf: 'stretch' }}>
    <Box display="flex" flexDirection="column" sx={{ minWidth: 0 }}>
      <Typography variant="caption" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
        {getCustomerNames(lesson)}
      </Typography>
      {lesson.product && (
        <Typography variant="caption" sx={{ fontSize: '0.65rem', whiteSpace: 'nowrap', opacity: 0.8 }}>
          {lesson.product.name}
        </Typography>
      )}
    </Box>
    <Box sx={{ position: 'absolute', bottom: 0, right: 0, display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {lesson.lessonType === LessonType.Private ? (
        <PersonIcon sx={{ fontSize: 12 }} />
      ) : (
        <GroupIcon sx={{ fontSize: 12 }} />
      )}
      <Typography variant="caption">{getSkierCount(lesson)}</Typography>
    </Box>
  </Box>
)
